const PLACEHOLDER_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const LAZY_ITEM_SELECTOR = '.l-projects-overview__item, .c-blog-item, .c-blog-cards__single';

function loadLazyImage(img) {
    if (!img?.dataset?.src) {
        return;
    }

    const item = img.closest(LAZY_ITEM_SELECTOR);
    item?.classList.add('is-loading');

    const onDone = () => {
        item?.classList.remove('is-loading');
        img.classList.add('is-loaded');
        img.removeEventListener('load', onDone);
        img.removeEventListener('error', onDone);
    };

    img.addEventListener('load', onDone);
    img.addEventListener('error', onDone);

    img.src = img.dataset.src;
    delete img.dataset.src;

    if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        delete img.dataset.srcset;
    }

    if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
        delete img.dataset.sizes;
    }

    if (img.complete && img.src !== PLACEHOLDER_SRC) {
        onDone();
    }
}

let lazyImageObserver = null;

function getLazyImageObserver() {
    if (lazyImageObserver || !('IntersectionObserver' in window)) {
        return lazyImageObserver;
    }

    lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            const img = entry.target.matches('img.js-lazy-image')
                ? entry.target
                : entry.target.querySelector('img.js-lazy-image[data-src]');

            if (img) {
                loadLazyImage(img);
            }

            lazyImageObserver.unobserve(entry.target);
        });
    }, {
        rootMargin: '200px 0px',
        threshold: 0.01,
    });

    return lazyImageObserver;
}

export function initLazyImages(root = document) {
    const images = root.querySelectorAll('img.js-lazy-image[data-src]');

    if (!images.length) {
        return;
    }

    const observer = getLazyImageObserver();

    if (!observer) {
        images.forEach(loadLazyImage);
        return;
    }

    images.forEach((img) => {
        const item = img.closest(LAZY_ITEM_SELECTOR);
        observer.observe(item || img);
    });
}

window.decolegnoInitLazyImages = initLazyImages;

function bootLazyImages() {
    initLazyImages();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootLazyImages);
} else {
    bootLazyImages();
}
